import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-menu-slide"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Licenses ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Databases ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Invoices ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Referral program ")
const _hoisted_6 = { class: "credits-mobile" }
const _hoisted_7 = { class: "balance" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Credits: ")
const _hoisted_9 = { class: "add-button" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Top up ")
const _hoisted_11 = { class: "user-block" }
const _hoisted_12 = {
  key: 0,
  class: "user"
}
const _hoisted_13 = {
  key: 1,
  class: "user-edit"
}
const _hoisted_14 = {
  key: 2,
  class: "user-logout"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_icon = _resolveComponent("a-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_a_menu_item = _resolveComponent("a-menu-item")
  const _component_a_menu = _resolveComponent("a-menu")
  const _component_DollarOutlined = _resolveComponent("DollarOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")

  return (_ctx.store.state.auth.isAuthenticated)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_a_menu, {
          mode: "inline",
          selectedKeys: _ctx.selectedKeys
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "Home" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_icon, { type: "check-circle" }),
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "Databases" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  id: "test",
                  to: "/databases"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_icon, { type: "plus-circle" }),
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "Invoices" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/invoices" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_icon, { type: "file-done" }),
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "Referral" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/referral" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_icon, { type: "share-alt" }),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selectedKeys"]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("span", null, _toDisplayString(_ctx.converter(_ctx.credits)), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_a_button, {
              type: "dashed",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push('/invoice-create'))),
              block: ""
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_DollarOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          (_ctx.store.state.auth.isAuthenticated)
            ? (_openBlock(), _createBlock("div", _hoisted_12, " Account: " + _toDisplayString(_ctx.store.state.auth.user.email), 1))
            : _createCommentVNode("", true),
          (_ctx.store.state.auth.isAuthenticated)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode(_component_router_link, { to: "/profile" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SettingOutlined)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.store.state.auth.isAuthenticated)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode(_component_LogoutOutlined, { onClick: _ctx.logOut }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}